// extracted by mini-css-extract-plugin
module.exports = {"background":"#f9fdf7","lightGreen":"#84a98c","darkGreen":"#52796f","navy":"#2d3142","black":"#131313"};